/** Saves a Blob as a file through a temporary link. */
export const downloadBlob = (blob: Blob, filename: string) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  // Revoking in the same tick can cancel the download in some browsers.
  window.setTimeout(() => window.URL.revokeObjectURL(url), 1000);
};

export interface CsvColumn<T> {
  header: string;
  value: (row: T) => string | number | null | undefined;
}

// Spreadsheets run cells that start with these as formulas; a leading quote keeps them as text.
const FORMULA_START = /^[=+\-@\t\r]/;

const csvCell = (value: string | number | null | undefined): string => {
  if (value === null || value === undefined) {
    return "";
  }
  if (typeof value === "number") {
    return String(value);
  }
  const text = FORMULA_START.test(value) ? `'${value}` : value;
  return /[",\n\r]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

/** Rows → CSV text (header line first, CRLF line ends, as spreadsheets expect). */
export const toCsv = <T>(rows: T[], columns: CsvColumn<T>[]): string =>
  [
    columns.map((column) => csvCell(column.header)).join(","),
    ...rows.map((row) => columns.map((column) => csvCell(column.value(row))).join(",")),
  ].join("\r\n");

/** Downloads rows as a UTF-8 CSV file; the byte-order mark makes Excel read ₹ and names right. */
export const downloadCsv = <T>(rows: T[], columns: CsvColumn<T>[], filename: string) =>
  downloadBlob(new Blob(["\ufeff", toCsv(rows, columns)], { type: "text/csv;charset=utf-8" }), filename);
